module.exports = __webpack_public_path__ + "img/icon-success.50b76e3c.png";